import { render, staticRenderFns } from "./mypage.vue?vue&type=template&id=1c4d242b&scoped=true&"
import script from "./mypage.vue?vue&type=script&lang=js&"
export * from "./mypage.vue?vue&type=script&lang=js&"
import style0 from "./mypage.vue?vue&type=style&index=0&id=1c4d242b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d242b",
  null
  
)

export default component.exports